import { HStack, StackProps } from "@chakra-ui/react";
import { ChangeEventHandler, FocusEventHandler } from "react";
import { FieldError } from "react-hook-form";

import AnimatedInput from "./AnimatedInput";

interface InputProps {
  error?: FieldError;
  required?: boolean;
  dataTest?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
}

interface IProps extends StackProps {
  minInputProps: InputProps;
  maxInputProps: InputProps;
  dataTest?: string;
}

const FormRange = ({
  minInputProps,
  maxInputProps,
  dataTest,
  ...props
}: IProps): JSX.Element => (
  <HStack spacing={0} {...props} data-test={dataTest}>
    <AnimatedInput
      data-test="setPriceFrom"
      name="min"
      label="Od"
      type="number"
      inputParentProps={{
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderRightWidth: "0.5px",
      }}
      {...minInputProps}
    />
    <AnimatedInput
      data-test="setPriceTo"
      name="max"
      label="Do"
      type="number"
      inputParentProps={{
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeftWidth: "0.5px",
      }}
      {...maxInputProps}
    />
  </HStack>
);

export default FormRange;
